module.exports = __webpack_public_path__ + "static/oralegale.476b4deb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/partners/oralegale.jpg
// module id = 1620
// module chunks = 35783957827783